// src/app/research-themes/loading.tsx
'use client';

import React from 'react';
import {
  Box,
  Container,
  Skeleton,
  Card,
  CardContent,
} from '@mui/material';

import { withOpacity } from '@/lib/colors';
import { useColorTheme } from '@/components/ColorModeProvider';

export default function Loading() {
  const colors = useColorTheme();

  return (
    <Box sx={{ minHeight: '100vh', background: colors.background.default }}>
      {/* Hero Section Skeleton — height matches PageHero default so the
          loading state doesn't taller-than-content snap when the real page mounts. */}
      <Box
        sx={{
          minHeight: '32vh',
          display: 'flex',
          alignItems: 'center',
          background: colors.background.hero,
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', color: colors.text.primary }}>
            <Skeleton 
              variant="text" 
              height={60} 
              width="60%" 
              sx={{ bgcolor: withOpacity(colors.text.primary, 0.15), mx: 'auto', mb: 2 }} 
            />
            <Skeleton 
              variant="text" 
              height={24} 
              width="80%" 
              sx={{ bgcolor: withOpacity(colors.text.primary, 0.1), mx: 'auto' }} 
            />
          </Box>
        </Container>
      </Box>

      {/* Overview Section Skeleton */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Card
          sx={{
            p: 4,
            mb: 6,
            background: colors.background.elevated,
            border: `1px solid ${colors.border.secondary}`,
          }}
        >
          <Skeleton 
            variant="text" 
            height={40} 
            width="40%" 
            sx={{ bgcolor: withOpacity(colors.text.primary, 0.15), mx: 'auto', mb: 3 }} 
          />
          <Skeleton 
            variant="text" 
            height={20} 
            sx={{ bgcolor: withOpacity(colors.text.primary, 0.1), mb: 1 }} 
          />
          <Skeleton 
            variant="text" 
            height={20} 
            sx={{ bgcolor: withOpacity(colors.text.primary, 0.1), mb: 1 }} 
          />
          <Skeleton 
            variant="text" 
            height={20} 
            width="70%" 
            sx={{ bgcolor: withOpacity(colors.text.primary, 0.1) }} 
          />
        </Card>

        {/* Theme Cards Skeleton */}
        {Array.from({ length: 6 }, (_, index) => (
          <Card 
            key={index} 
            sx={{ 
              background: colors.gradients.card, 
              mb: 4, 
              border: `1px solid ${colors.border.primary}`,
              position: 'relative',
            }}
          >
            <Skeleton 
              variant="circular" 
              width={80} 
              height={80} 
              sx={{ 
                bgcolor: withOpacity(colors.text.primary, 0.1),
                position: 'absolute',
                top: -20,
                right: 24,
                zIndex: 10,
              }} 
            />
            <Skeleton 
              variant="rectangular" 
              height={200} 
              sx={{ bgcolor: withOpacity(colors.text.primary, 0.1) }} 
            />
            <CardContent sx={{ p: 4 }}>
              <Skeleton 
                variant="text" 
                height={40} 
                width="70%" 
                sx={{ bgcolor: withOpacity(colors.text.primary, 0.15), mb: 3 }} 
              />
              <Skeleton 
                variant="text" 
                height={20} 
                sx={{ bgcolor: withOpacity(colors.text.primary, 0.1), mb: 1 }} 
              />
              <Skeleton 
                variant="text" 
                height={20} 
                sx={{ bgcolor: withOpacity(colors.text.primary, 0.1), mb: 1 }} 
              />
              <Skeleton 
                variant="text" 
                height={20} 
                width="60%" 
                sx={{ bgcolor: withOpacity(colors.text.primary, 0.1) }} 
              />
            </CardContent>
          </Card>
        ))}
      </Container>
    </Box>
  );
}